import { css } from 'linaria';

export const reviewContentContainer = css`
  display: none;
`;

export const reviewContentBg = css`
  position: absolute;
  background-color: var(--background-accent);
  top: 0;
  opacity: 0.4;
  height: 100%;
  width: 100%;
  border-radius: var(--rounding-xl);
`;

export const reviewContent = css`
  border-radius: var(--rounding-xl);
  background-color: var(--background-accent);
  padding: 12px 36px 12px 12px;
  position: absolute;
  bottom: 16px;
  right: 16px;
  left: 16px;

  @media (--only-mobile) {
    bottom: 8px;
    right: 8px;
    left: 8px;
    padding-right: 18px;
  }
`;

export const reviewRating = css`
  margin-bottom: 10px;

  @media (--only-mobile) {
    margin-bottom: 10px;
  }
`;

export const reviewText = css`
  &&& {
    max-height: 74px;
    overflow: hidden;
    text-overflow: ellipsis;
    --webkit-line-camp: 3;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    margin-bottom: 6px;

    @media (--only-mobile) {
      font-size: 11px;
      line-height: 14px;
    }
  }
`;

export const reviewCardInfoIconContainer = css`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: var(--background-accent);
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (--only-mobile) {
    width: 20px;
    height: 20px;
  }
`;
